export default {
  templateHeader: {
    title: 'クローン音声アセット',
    desc: 'キャラクターにカスタム音声をクローンし、よりリアルな吹き替え効果を実現します。',
    addVoice: 'クローン音声を追加',
  },
  table: {
    confirmDelete: {
      message: '削除すると元に戻すことはできません。削除しますか？',
      title: '音声を削除する',
    },
    runningAlert: '音声を追加中です。しばらくお待ちください。',
    action: {
      stop: '停止',
      play: '再生',
      edit: '編集',
    },
    added: '追加済み',
  },
  addVoice: {
    form: {
      sample: '音声サンプル',
      separation: '背景音楽を同時に削除する',
      name: '名前',
      namePlaceholder: '入力してください',
      desc: '説明',
      descPlaceholder:
        'この音声を説明してください。例えば、「年配のアメリカ人男性の声で、喉が少し枯れた感じ。ニュース放送に最適です。」',
      upload: {
        asset: 'ライブラリから追加',
        tip_1:
          '理想的な音声の長さは1〜2分（1秒以上）、明瞭で残響や欠陥、背景ノイズがないもの。（音声と動画に対応）',
        tip_2:
          '音声品質はクローン結果に最も影響する要因で、声そのもの、言語、アクセント、録音品質を含みます。',
        tip_3:
          '音声の一貫性を保ち、プロセス全体でトーンとパフォーマンスが安定していることを確認してください。',
        tip_4:
          '音量は適度で、理想的な範囲は-23 dBから-18 dB RMS、最大は-3 dBです。',
        formatError: 'サポートされていないファイル形式',
        durationError:
          '長さは{s}秒以上である必要があります。再度アップロードしてください。',
      },
      edit: '音声を編集',
      confirm: '新規追加',
    },
    disabledTips: {
      usedSlot: '追加されたクローン音声の数が上限に達しました。',
      voiceEdit: '今月のクローン音声編集回数が上限に達しました。',
    },
  },
}
